import * as ApiManager from './_manager';
import store from '../store';

export const subscription = {
  create: payload => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/subscription/create`,
      payload
    );
  },
  get : payload => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/subscription/get`,
      payload
    );
  },
  cancel: payload => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/subscription/${payload.subscription_id}/cancel`,
      payload
    );
  },
  resume: payload => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/subscription/${payload.subscription_id}/resume`,
      payload
    );
  },
};
